import React from 'react'
import "./rentalSummary.scss"
import { RentalSummaryDetails } from '../../components'

const RentalSummary = () => {
  return (
    <div className='rental-summary-page'>
      <RentalSummaryDetails />
    </div>
  )
}

export default RentalSummary